import { action, createRequestTypes } from './base';

export const dnActionTypes = {
  GET_DN: createRequestTypes('GET_DN'),
  GET_DN_BY_ID: createRequestTypes('GET_DN_BY_ID'),
  CREATE_DN: createRequestTypes('CREATE_DN'),
  UPDATE_DN: createRequestTypes('UPDATE_DN'),
  UPDATE_STATUS_DN: createRequestTypes('UPDATE_STATUS_DN'),
  UPDATE_DN_WORKFLOW_STEP: createRequestTypes('UPDATE_DN_WORKFLOW_STEP'),
  DELETE_DN: createRequestTypes('DELETE_DN'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param dnId
 * @param dnEntityId
 * @param dnEntityType
 * @param status
 * @param limit
 * @param page
 * @param tenantSellerId
 * @param selectedEntityType
 * @param callback
 */
class DNActions {
  /**
   * @param {*} orgId
   * @param {*} dnId
   * @param {*} page
   * @param tenantId
   * @param customerId
   * @param tenantSellerId
   * @param dnId
   * @param status
   * @param searchKeyword
   * @param {*} limit
   * @return
   */
    getDN = (tenantId, tenantSellerId, dnId, status, page, limit, searchKeyword, is_list) => action(dnActionTypes.GET_DN.REQUEST, {
      tenantId, tenantSellerId, dnId, status, page, limit, searchKeyword, is_list,
    })

    /**
     *
     * @param {*} getDNLoading
     * @return
     */
     getDNLoading = (getDNLoading) => action(dnActionTypes.GET_DN.LOADING, {
       getDNLoading,
     })

     /**
      * @return
      * @param dns
      * @param debitNotes
      * @param customFields
      */
     getDNSuccess = (debitNotes) => action(dnActionTypes.GET_DN.SUCCESS, {
       debitNotes,
     })

     /**
      * @param {*} tenantId
      * @param orgId
      * @param {*} dnId
      * @return
      */
     getDNById = (tenantId, dnId,callback) => action(dnActionTypes.GET_DN_BY_ID.REQUEST, {
       tenantId, dnId,callback
     })

     /**
      *
      * @param {*} getDNByIdLoading
      * @return
      */
     getDNByIdLoading = (getDNByIdLoading) => action(dnActionTypes.GET_DN_BY_ID.LOADING, {
       getDNByIdLoading,
     })

     /**
      * @return
      * @param selectedDN
      * @param dnData
      */
      getDNByIdSuccess = (selectedDN) => action(dnActionTypes.GET_DN_BY_ID.SUCCESS, {
        selectedDN,
      })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createDN = (payload, callback) => action(dnActionTypes.CREATE_DN.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createDNLoading
     * @return
     */
    createDNLoading = (createDNLoading) => action(dnActionTypes.CREATE_DN.LOADING, {
      createDNLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updateDN = (payload, callback) => action(dnActionTypes.UPDATE_DN.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateDNLoading
      * @return
      */
     updateDNLoading = (updateDNLoading) => action(dnActionTypes.UPDATE_DN.LOADING, {
       updateDNLoading,
     })

    /**
     * @param tenantId
     * @param dnId
     * @param orgId
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    updateDNStatus = (payload, callback) => action(dnActionTypes.UPDATE_STATUS_DN.REQUEST, {
      payload, callback,
    })

    /**
     * @param updateDNStatusLoading
     * @return {{type: *}}
     */
     updateDNStatusLoading = (updateDNStatusLoading) => action(dnActionTypes.UPDATE_STATUS_DN.LOADING, {
       updateDNStatusLoading,
     })

     /**
      * @param tenantId
      * @param dnId
      * @param orgId
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
    deleteDN = (payload, callback) => action(dnActionTypes.DELETE_DN.REQUEST, {
      payload, callback,
    })

    /**
     * @param deleteDNLoading
     * @return {{type: *}}
     */
     deleteDNLoading = (deleteDNLoading) => action(dnActionTypes.DELETE_DN.LOADING, {
       deleteDNLoading,
     })

     /**
      * @param tenantId
      * @param dnId
      * @param orgId
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
        updateDNWorkflowStep = (payload, callback) => action(dnActionTypes.UPDATE_DN_WORKFLOW_STEP.REQUEST, {
          payload, callback,
        })

        /**
         * @param updateDNStatusLoading
         * @param updateDNWorkflowStepLoading
         * @param deleteDNLoading
         * @return {{type: *}}
         */
         updateDNWorkflowStepLoading = (updateDNWorkflowStepLoading) => action(dnActionTypes.UPDATE_DN_WORKFLOW_STEP.LOADING, {
           updateDNWorkflowStepLoading,
         })
}

export default new DNActions();
